var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBankOfAmerica = function SvgBankOfAmerica(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "bank-of-america_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 40 26",
    style: {
      enableBackground: "new 0 0 40 26"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".bank-of-america_svg__st1{fill:#0a68b1}")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M0 0h40v26H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.465 10.205c.585.26 1.3.52 1.885.78-1.95.78-3.9 1.755-5.785 2.86-.585-.325-1.235-.585-1.885-.91 1.95-1.105 3.835-2.015 5.785-2.73M15.125 9.295c-2.08.65-4.03 1.56-5.915 2.535.585.26 1.17.455 1.755.65 1.82-1.105 3.77-1.95 5.785-2.665-.585-.13-1.04-.325-1.625-.52",
    className: "bank-of-america_svg__st1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.82 10.14c-1.625-.78-3.315-1.495-5.005-1.95-.585.195-1.235.39-1.755.52 1.755.52 3.51 1.17 5.135 2.015a8.149 8.149 0 0 1 1.625-.585m2.665-.845c-1.625-.715-3.38-1.365-5.135-1.82-.52.13-1.105.26-1.625.39 1.69.52 3.445 1.17 5.07 1.885.52-.13 1.04-.325 1.69-.455m4.225 1.43c-4.095 1.43-8.06 3.38-11.57 5.915.845.52 1.69 1.105 2.6 1.69a47.976 47.976 0 0 1 10.985-6.5c-.65-.39-1.365-.715-2.015-1.105M25.85 9.36c-4.29 1.17-8.32 2.925-12.09 5.395.78.455 1.625.845 2.47 1.3 3.64-2.535 7.605-4.42 11.83-5.72-.78-.26-1.495-.65-2.21-.975",
    style: {
      fill: "#e31b37"
    }
  }));
};
export default SvgBankOfAmerica;